<template>
    <div class="comp-logPanel comp">
        <el-form v-model="conditions" :inline="true" class="conditions">
            <el-form-item label="排列顺序">
                <el-switch v-model="conditions.asc" v-on:change="reverseLogs" />
            </el-form-item>
            <el-form-item label="日志类型">
                <el-checkbox-group v-model="conditions.types">
                    <el-checkbox label="Trace" />
                    <el-checkbox label="Debug" />
                    <el-checkbox label="Info" />
                    <el-checkbox label="Action" />
                    <el-checkbox label="Error" />
                    <el-checkbox label="Fatal" />
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="">
                <el-button type="danger" size="mini" plain v-on:click="clearLogs">
                    清空日志
                </el-button>
            </el-form-item>
        </el-form>
        <div class="log-window">
            <div
                v-for="(item,index) in logs"
                v-show="showType(item.type)"
                :key="item.id"
                class="logitem"
                :class="[{ expand: item.isExpand === true }, item.type]"
                v-on:click="toggleCollapse(index)"
            >
                <i class="fa fa-angle-right" /> [{{ getTimeStr(item.time) }}] [{{ item.type }}]
                {{ item.msg }}
            </div>
        </div>
    </div>
</template>

<script>
import format from "date-fns/format";

export default {
    data () {
        return {
            conditions: {
                asc: true,
                types: ["Trace", "Debug", "Info", "Action", "Error", "Fatal"]
            },
            logs: []
        };
    },
    mounted () {
        this.logs = this.$log.get();
    },
    methods: {
        getTimeStr (t) {
            return format(t, "HH:mm:ss:SSS");
        },
        toggleCollapse (index) {
            let o = this.logs[index];
            o.isExpand = !o.isExpand;
            this.$set(this.logs, index, o);
        },
        reverseLogs () {
            let ary = [];
            for (let item of this.logs) {
                ary.unshift(item);
            }
            this.logs = ary;
        },
        clearLogs () {
            this.logs = [];
            this.$log.clear();
        },
        showType (t) {
            let flag = false;
            for (let item of this.conditions.types) {
                if (item.toLowerCase() === t) {
                    flag = true;
                }
            }
            return flag;
        }
    }
};
</script>
<style lang="scss">
.comp-logPanel {
    .conditions {
        height: 44px;
    }
    .log-window {
        width: 100%;
        height: 30vh;
        background: #fff;
        border: 1px solid #f1f1f1;
        overflow-y: auto;
        overflow-x: hidden;
        .logitem {
            height: 16px;
            overflow: hidden;
            margin: 5px;
            padding: 5px;
            border-bottom: 1px solid #f1f1f1;
            &:hover {
                background: #99ccff;
                cursor: pointer;
            }
        }
        .logitem.expand {
            height: auto;
        }
        .trace {
            color: #999;
        }
        .debug {
            color: #009933;
        }
        .info {
            color: #336699;
        }
        .warn {
            color: #e99400;
        }
        .error {
            color: #ff0000;
        }
        .fatal {
            color: #9900ff;
        }
    }
}
</style>
